<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <product-filter/>
    </div>
    <div class="aco-details-box">
      <product-list/>
    </div>
  </div>
</template>

<script>
  import ProductFilter from './ProductFilter'
  import ProductList from './ProductList'

  export default {
    components: {
      productFilter: ProductFilter,
      productList: ProductList
    }
  }
</script>
